// extracted by mini-css-extract-plugin
module.exports = {"link":"jascroLink_link__AdaEi","dark":"jascroLink_dark__IJuc7","light":"jascroLink_light__Jd8QE"};